import { JtechException, TokenExpiredException } from 'jtech-web-exceptions'
import { GlobalController } from '../global/GlobalController'
import router from 'src/router'

export default class JtechWasteException extends JtechException {
  static throwWasteException (exception) {
    try {
      super.throwException(exception)
    } catch (ex) {
      this._switchCustomException(ex)
    }
  }

  static _switchCustomException (exception) {
    if (exception instanceof TokenExpiredException) {
      this._onTokenExpiredException(exception.exception)
    }
  }

  static _onTokenExpiredException (exception) {
    const globalController = GlobalController.getInstance()
    globalController.setAuthResp(null)
    router.push({ name: 'login', params: { reload: true, expired: true } })
  }
}
